/**
 * `/sales/receipts/$receiptId` — receipt detail route. Renders the
 * document-first detail page (sticky header + ribbon + doc-stage
 * voucher + sticky rail), matching the invoice/bill detail chrome.
 *
 * @see apps/web/src/features/receipts/detail/ — page composition
 * @see docs/adr/0019-fx-invoice-receipt-redesign.md
 */
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { ReceiptDetailPage } from "../../../../features/receipts/detail/index.ts";

export const Route = createFileRoute("/(workspace)/sales/receipts/$receiptId")({
  params: {
    parse: (raw) => ({ receiptId: z.string().uuid().parse(raw.receiptId) }),
    stringify: (parsed) => ({ receiptId: parsed.receiptId }),
  },
  component: ReceiptDetailRoute,
});

function ReceiptDetailRoute() {
  const { receiptId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Sales" },
        { label: "Receipts", to: "/sales/receipts" },
        { label: `RCP-${receiptId.slice(0, 8)}` },
      ]}
      // Same shell-strip as invoice/bill detail — sticky bands span viewport.
      viewportClassName="p-0 md:p-0"
      contentClassName="max-w-none"
    >
      <ReceiptDetailPage receiptId={receiptId} />
    </WorkspaceShell>
  );
}
